import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';

function FetchCMCategoriesService(token,data) {
    return axios.post(`${CURRENT_API_URL}/contentmanagement/fetchCMAssetCategory`, data,{
        headers: {
            'Authorization': token,
        }
    }).then(res => {
            return res.data;        
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while fetching data, please try again later.");
        return false;
    });
}


export default FetchCMCategoriesService;